import styled from 'styled-components';

export const HeaderStyle = styled.div`
  width: 100%;
  position: fixed;
  top: 48px;
  left: 0;
  z-index: 3;

  .header-container {
    max-width: 376px;
    margin: 0 auto;
    width: 100%;
    display: flex;
    padding: 22px 30px;
    background: white;
  }
`;
